import React, {  } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import { ddados } from "../consultarProtocolo.ddados";
import autobind from "react-autobind";
import RedeSIMForm from "../../redeSIM.form";
import consultarProtocoloSelector from "../store/consultarProtocolo.selectors";
import consultarProtocoloActions from "../store/consultarProtocolo.actions";
import PesquisaProtocoloModal from "./consultaProtocolo.modal";
import GridConsultaProtocolo from "./consultaProtocolo.grid";
import ConsultaProtocoloGridPesquisa from "./consultaProtocolo.gridPesquisa"
import ViewAnaliseModal from './viewAnaliseProtocolo.modal';

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  verifyCallback(response) {
    this.props.consultarProtocoloActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.consultarProtocoloActions.setTokenRecaptcha("");
  }

  recaptchaRef(ref){
    this.props.consultarProtocoloActions.setRecaptchaResetRef(ref?.reset);
  }

  onSubmit(values) {
    this.props.consultarProtocoloActions.pesquisarConsultarProtocolo(values);
  }

  onSearch() {
    this.props.consultarProtocoloActions.toggleModalConsultarProtocolo();
  }

  componentDidMount(){
    this.props.consultarProtocoloActions.setGridConsultarProtocolo([]);
  }

  render() {
    const { consultarProtocolo } = this.props.consultarProtocoloSelector;
    const gridPesquisaConsultarProtocolo = consultarProtocolo.GridConsultarProtocoloPesquisa?.length > 0;
    const gridConsultarProtocolo = (consultarProtocolo.GridConsultarProtocolo?.length > 0
      && !gridPesquisaConsultarProtocolo);
    const redeSimForm = (!gridConsultarProtocolo && !gridPesquisaConsultarProtocolo);

    return (
      <>
      {consultarProtocolo.ViewAnaliseModalToggle && (
        <ViewAnaliseModal />
      )}

      <PesquisaProtocoloModal show={consultarProtocolo.PesquisaProtocoloModalToggle} />

      { (gridConsultarProtocolo && !consultarProtocolo.ViewAnaliseModalToggle) && (
        <GridConsultaProtocolo />
      )}

      { gridPesquisaConsultarProtocolo && (
        <ConsultaProtocoloGridPesquisa />
      )}

      { redeSimForm && (
        <RedeSIMForm
          title={ddados.Titulo}
          recaptchaRef={this.recaptchaRef}
          verifyCallback={this.verifyCallback}
          expiredCallback={this.expiredCallback}
          onSubmit={this.onSubmit}
          onSearch={this.onSearch}
          isView
        />
      )}
    </>
    );
  }
}

export default connect({
  actions: {
    consultarProtocoloActions
  },
  selectors: {
    consultarProtocoloSelector
  }
})(Container);

